import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { CookieService } from '../Services/cookie';
import { Subject } from "rxjs";
import { NgZone } from '@angular/core';
import { CommonService } from '../Services/common.service';
import { TopupServiceService } from '../Services/topup-service.service';
import { AmountFormatterPipe } from '../pipes/amount-formatter.pipe';
import { AuthService } from '../Services/auth.service';
import { Hash, HMAC } from "fast-sha256";
import { HttpServiceService } from '../Services/http-service.service';
import { HttpHeaders } from '@angular/common/http';

import * as CryptoJS from 'crypto-js';
// import { data } from 'jquery';

declare var InApp: any;
// declare function Open();

@Component({
  selector: "app-select-payment-method",
  templateUrl: "./select-payment-method.component.html",
standalone:false,
  styleUrls: ["./select-payment-method.component.scss"],
})
export class SelectPaymentMethodComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  selectedgateway: boolean = false;
  idnumber: string;
  prodType: string;
  CardDigit: string;
  internalId: string = "";
  amount: any;
  num: number;
  flow: string;
  Accnum: string;
  transactionRefId: any;
  udF1: string;
  udF2: string;
  secKey: any;
  finalAmount: any;
  merchanID: any;
  Refrancenumber: any;
  refranceNumber: any;
  RefID: string;
  newRefranceID: void;
  newMarchentID: void;


  constructor(private router: Router, private cookieService: CookieService, private ngZone: NgZone, private commonP: CommonService,
    private topup: TopupServiceService, private amountpipe: AmountFormatterPipe, public auth: AuthService,
    private http: HttpServiceService
  ) { }

  async ngOnInit(): Promise<any> {

    await this.commonP.presentLoading();
    let I =await this.cookieService.get("CVa21f11", true);
    if (I) {
      this.idnumber = I;
    }

    let a =await this.cookieService.get("flow", true);

    if (a) {
      this.flow = a;

    }

    let Id =await this.cookieService.get("InternalId", true);
    if (Id) {
      this.internalId = Id;
    }

    let P =await this.cookieService.get("prodType", true);
    if (P) {
      this.prodType = P;
    }
    let C =await this.cookieService.get("Dix2lf4", true);
    if (C) {
      this.CardDigit = C;
    }
    let AC =await this.cookieService.get("tu42f", true);

    if (AC) {

      this.Accnum = AC;

    }
    let A =await this.cookieService.get("amount", true);
    if (A) {
      this.amount = this.amountpipe.transform(A)

      this.amount = JSON.parse(this.amount)

    }

    let U1 =await this.cookieService.get("UdF1", true);
    if (U1) {
      this.udF1 = U1;

    }

    let U2 =await this.cookieService.get("UDF2", true);
    if (U2) {
      this.udF2 = U2;

    }
    this.auth.accessToken = await this.commonP.Get("token");

    if (this.auth.detailuser) {
      this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {

        // if (data?.status == 401) {

        //   await this.commonP.hideLoading();
        //   this.commonP.ParseErrorAlert("", "", this.router, data);
        // }
        // else 
        if (data?.response?.code == 1) {
          this.commonP.hideLoading();
        }
        else {
          await this.commonP.hideLoading();
          if (this.flow != 'Quickpay') {
            this.commonP.ParseErrorAlert("", "", this.router, data);
          }
        }
  
  
      });
    } else {
      await this.commonP.hideLoading();
      console.log("No data then bhaag jao");
    }
  }


  SelectGateway(e, num) {
    if (e.srcElement.checked) {

      this.selectedgateway = e.srcElement.checked;
      this.num = num;

    }
  }


  payCardSuccess() {

    if (this.internalId != '' && this.internalId != null && (this.prodType == 'C' || this.prodType == 'L') && (this.flow == 'Pay' || this.flow == '' || this.flow == undefined)) {

      this.InititePayment();

    }
    else {

      this.commonP.presentLoading();
      let that=this;

      let obj = this.topup.ValidatePaymentObject
      obj.uniqueId = this.commonP.Guid(),
        obj.idNumber = this.idnumber,
        obj.accountType = this.prodType,
        obj.mobileNumber = "",
        obj.accountNumber = this.prodType == 'C' ? this.CardDigit : this.Accnum,
        obj.vendorId = this.num,
        obj.amount = this.amount,
        obj.isInquire = this.flow == 'Inquire' ? true : false;
      obj.udF1 = this.udF1,
        obj.udF2 = this.udF2

      this.topup.ValidatePayment(obj).then((res: any) => {

        this.newRefranceID= res?.response?.content?.internalId
          this.newMarchentID= res?.response?.content?.merchantId
        if (res?.error?.response?.code == 1) {

          this.commonP.hideLoading();
          
          this.cookieService.delete("IdNumber")
          // this.cookieService.delete("prodType")
          // this.cookieService.delete("flow")
          this.cookieService.delete("CardDigit")
          this.cookieService.delete("Accnum")
          // this.cookieService.delete("amount")

          this.commonP.ParseErrorAlert('', 'OK', this.router, res);
        }
        else if (res?.error?.response?.code == 7) {

          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert('', 'OK', this.router, res);
        }

        else if (res?.response?.code == 1) {
          console.log("res", res)


          if (this.num == 2) {
            // this.cookieService.delete("IdNumber")
            // this.cookieService.delete("UdF1")
            // this.cookieService.delete("UdF2")
            // this.cookieService.delete("CardDigit")
            // this.cookieService.delete("Accnum")
            let tranamount = this.amountpipe.transform(res?.response?.content?.totalAmount);
            // let tranamount = this.amount+'.000';



            //Concatenated string for HASH
            var Hstring = `appId="${res?.response?.content?.appId}",merchantId="${res?.response?.content?.merchantId}",referenceNumber="${res?.response?.content?.internalId}",transactionAmount="${tranamount.toString()}",transactionCurrency="BHD"`;
            // var Hstring = "appId='{{res?.response?.content?.appId}}',merchantId='{{res?.response?.content?.merchantId}}',referenceNumber='{{res?.response?.content?.internalId}}',transactionAmount=tranamount.toString(),transactionCurrency='BHD'";
            console.log('Hstring', Hstring)

            // var Hstring= 'appId="3665164969",merchantId="202009151",referenceNumber="21be40d2-8464-4ac0-8f8d-31554fa48e68",transactionAmount="6.000",transactionCurrency="BHD"'


            //Secret Key converted in base64 from Validate payment API
            //  let secretKey = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(res?.response?.content?.secretKey));

            //Secret Key 
            let secretKey = res?.response?.content?.secretKey;
            console.log('key', secretKey);


            // SHA256Hmac signature using HAshstring and Secret key
            var createHash = CryptoJS.HmacSHA256(Hstring, secretKey);
            console.log('createHash', createHash);


            //convert SHA256Hmac into base64
            var hashInBase64 = CryptoJS.enc.Base64.stringify(createHash);
            console.log("hashInBase64", hashInBase64);


            var secureHash = hashInBase64;

            console.log('secureHash', secureHash);

            var option = {
              appId: res?.response?.content?.appId,
              referenceNumber: res?.response?.content?.internalId,
              transactionAmount: tranamount,
              merchantId: res?.response?.content?.merchantId,
              transactionCurrency: "BHD",
              hideMobileQR: false,
              showResult: true,
              paymentType: "web",
              secure_hash: secureHash,
              hashedString: createHash,
            }
            console.log("benefitpaybody", option)


            let headers = new HttpHeaders();

            headers = headers.append("s X-FOO-Signature-Type", secureHash)
            InApp.open(option,
              (data) => {
                let that=this;

                InApp.close()

                that.commonP.presentLoading();
                // this.http.FooVal = ""
                console.log("dATA", data)
                this.quickPaymentBenefitPay()
              },
              (error) => {

                console.log("error", error)
              },
              (closeCallback)=>{

                // that.ngZone.run(() => {
                //   that.commonP.hideLoading();
                //   that.router.navigateByUrl("/SuccessPayment");
                // });

                //  that.router.navigateByUrl("/SuccessPayment");
                // this.router.navigateByUrl("/CardPage");
                // console.log("CLose call back");
           


              } 
              
              , { headers }
            )



            // this.commonP.hideLoading();


          }

          else {


            if (res?.response.content.url != null) {

              this.cookieService.delete("IdNumber")
              this.cookieService.delete("UdF1")
              this.cookieService.delete("UdF2")
              this.cookieService.delete("CardDigit")
              this.cookieService.delete("Accnum")
              // this.cookieService.delete("amount")
              this.commonP.hideLoading();

              window.location.href = res?.response.content.url;

            }
            else {

              this.commonP.hideLoading();
              this.commonP.ParseErrorAlert('', 'OK', this.router, "No URL Found");
            }
          }
        }
        else {

          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert('', 'OK', this.router, res);
        }
      })
    }

    //this.router.navigateByUrl("/PayCardSuccess");
  }

  InititePayment() {
   

    let body = {
      InternalId: this.internalId,
      VendorId:this.num, // 1 for benefit gateway, 2 for benefit pay
      AccountType:this.prodType, // C for Card, L for Loan
      Amount:this.amount
    };

    this.commonP.presentLoading();
    this.topup.InititePayment(this.auth.accessToken, body).then(async (data: any) => {

      if (data?.response.code == 1) {
        console.log("12345",data)
        
        this.secKey= data?.response?.content?.secretKey;
        if (this.num == 2) {
          // this.cookieService.delete("UdF1")
            // this.cookieService.delete("UdF2")
            // this.cookieService.delete("CardDigit")
            // this.cookieService.delete("Accnum")
            // let tranamount = this.amountpipe.transform(data?.response?.content?.totalAmount);


            // let tranamount = this.amount+'.000';



            //Concatenated string for HASH
            // var Hstring = `appId="${data?.response?.content?.appId}",merchantId="${data?.response?.content?.merchantId}",referenceNumber="${data?.response?.content?.internalId}",transactionAmount="${tranamount.toString()}",transactionCurrency="BHD"`;
            let totalAmount = data?.response?.content?.totalAmount;
let tranamount = totalAmount ? this.amountpipe.transform(totalAmount) : null;
// this.finalAmount=this.amount
let amountAsString = this.amount.toString(); // Convert amount to string if not already
this.finalAmount = amountAsString + '.000';
// Safeguard to handle the case where tranamount might be null
let tranamountStr = tranamount ? tranamount.toString() : '';
this.merchanID=data?.response?.content?.merchantId;
this.Refrancenumber=data?.response?.content?.id;

var Hstring = `appId="${data?.response?.content?.appId}",merchantId="${data?.response?.content?.merchantId}",referenceNumber="${data?.response?.content?.id}",transactionAmount="${this.finalAmount}",transactionCurrency="BHD"`;
// var Hstring = `appId:"8261679566",
//               merchantId:"202006101",
//               referenceNumber:"f9c46fa9-5e8d-43a7-a3ca-c86d70e74d57",
//               transactionAmount:"123.000",
//               transactionCurrency:"BHD",`;
// var Hstring = `appId="8261679566",merchantId="202006101",referenceNumber="f9c46fa9-5e8d-43a7-a3ca-c86d70e74d57",transactionAmount="123.000",transactionCurrency="BHD"`;


            // var Hstring = "appId='{{res?.response?.content?.appId}}',merchantId='{{res?.response?.content?.merchantId}}',referenceNumber='{{res?.response?.content?.internalId}}',transactionAmount=tranamount.toString(),transactionCurrency='BHD'";
            console.log('Hstring', Hstring)

            // var Hstring= 'appId="3665164969",merchantId="202009151",referenceNumber="21be40d2-8464-4ac0-8f8d-31554fa48e68",transactionAmount="6.000",transactionCurrency="BHD"'


            //Secret Key converted in base64 from Validate payment API
            //  let secretKey = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(res?.response?.content?.secretKey));

            //Secret Key 
            let secretKey = data?.response?.content?.secretKey;
            console.log('secretKey123', secretKey);


            // SHA256Hmac signature using HAshstring and Secret key
            var createHash = CryptoJS.HmacSHA256(Hstring, secretKey);

//             var jsonString = JSON.stringify(Hstring);
// var createHash = CryptoJS.HmacSHA256(jsonString, this.secKey);
            // var createHash = CryptoJS.HmacSHA256(Hstring, secretKey).toString(CryptoJS.enc.Hex);

            console.log('createHash', createHash);


            //convert SHA256Hmac into base64
            var hashInBase64 = CryptoJS.enc.Base64.stringify(createHash);
            console.log("hashInBase64", hashInBase64);


            var secureHash = hashInBase64;

            console.log('secureHash', secureHash);
            this.commonP.hideLoading();
            var option = {
              appId: data?.response?.content?.appId,
              referenceNumber: data?.response?.content?.id,
              transactionAmount: this.finalAmount,
              merchantId: data?.response?.content?.merchantId,
              transactionCurrency: "BHD",
              hideMobileQR: false,
              showResult: true,
              paymentType: "web",
              secure_hash: secureHash,
              hashedString: createHash,
            }
            console.log("benefitpaybody", option)


            let headers = new HttpHeaders();

            headers = headers.append("s X-FOO-Signature-Type", secureHash)
            
            InApp.open(option,
              (data) => {
                InApp.close()

                // this.http.FooVal = ""
                console.log("dATA", data)
                this.refranceNumber=data?.referenceNumber
                
              
                this.UpdatePaymentBenefitPay();
              },
              (error) => {

                console.log("error", error)
              },(closeCallback)=>{
                console.log("CLose call back");
              } ,{ headers }
            )


            // this.commonP.hideLoading();

        }
        else {
         
          this.transactionRefId = data?.response?.content?.id;
          this.cookieService.set("referenceId", this.transactionRefId,true);
          this.cookieService.delete("InternalId")
          // this.cookieService.delete("prodType")
          this.cookieService.delete("flow")
          // this.cookieService.delete("amount")

          window.location.href = data?.response?.content?.url;
        }

      }
      else if (data?.error?.response.code == 7) {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "", this.router, data);
      }
      else {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "", this.router, data);
      }
    });
  }

  PayCardSuccess() {
    // InApp.close()
    // this.router.navigateByUrl("/CardPage");
    // // setTimeout(() => {
    // //   this.router.navigateByUrl("/CardPage");
    // //   console.log("Close callback");
    // // }, 10000); // 10,000 milliseconds = 10 seconds
    let that=this;
    // InApp.close()
    // this.router.navigateByUrl("/SuccessPayment");
    // setTimeout(() => {
    //   this.router.navigateByUrl("/CardPage");
    //   console.log("Close callback");
    // }, 10000); // 10,000 milliseconds = 10 seconds
    that.ngZone.run(() => {
      that.commonP.hideLoading();
      that.router.navigateByUrl("/CardPage");
    });
   
  }
  QuickpayCard() {
    let that=this;
    // InApp.close()
    // this.router.navigateByUrl("/SuccessPayment");
    // setTimeout(() => {
    //   this.router.navigateByUrl("/CardPage");
    //   console.log("Close callback");
    // }, 10000); // 10,000 milliseconds = 10 seconds
    that.ngZone.run(() => {
      that.commonP.hideLoading();
      that.router.navigateByUrl("/SuccessPayment");
    });
  }
  PayCardfail() {
    this.router.navigateByUrl("/PayCardFailed");
  }
  UpdatePaymentBenefitPay(){

    let body = {
      referenceId: this.refranceNumber,
      merchantId: this.merchanID,
    };

    this.commonP.presentLoading();
    this.topup.UpdatePaymentBenefitPay(this.auth.accessToken, body).then(async (data: any) => {

      
      if (data?.error?.response.code == 7    ) {
        this.commonP.hideLoading();
        InApp.close()
        let failerData = data?.error?.response.content;
        this.router.navigate(["/PayCardFailed"], {
          queryParams: { failerData },
        });

       
        // this.commonP.ParseErrorAlert("", "", this.router, data);
        // this.PayCardfail()
      }
      else if (data?.response.code == 1) {
        console.log("sucessData",data)

        this.cookieService.delete("RefranceID");
        this.RefID=data.response.content.benefitRef
        console.log(this.RefID,"RefID");
        this.cookieService.set("RefranceID", this.RefID, true);
        this.PayCardSuccess();

      }
      else {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "", this.router, data);
      }
    }); 
  }

  quickPaymentBenefitPay(){

    let body = {
      referenceId: this.newRefranceID,
      merchantId: this.newMarchentID,
    };


    this.commonP.presentLoading();
    this.topup.quickPaymentBenefitPay(body).then(async (data: any) => {

      
      if (data?.error?.response.code == 7    ) {
        this.commonP.hideLoading();
        InApp.close()
        // let failerData = data?.error?.response.content;
        // this.router.navigate(["/PayCardFailed"], {
        //   queryParams: { failerData },
        // });

// new
let that=this;

that.ngZone.run(() => {
  let failerData = data?.error?.response.content;
  this.router.navigate(["/PayCardFailed"], {
    queryParams: { failerData },
  });
});


       
        // this.commonP.ParseErrorAlert("", "", this.router, data);
        // this.PayCardfail()
      }
      else if (data?.response.code == 1) {
        console.log("quickupdatepayment",data)
       
        this.cookieService.delete("RefranceID");
        this.RefID=data.response.content.benefitRef
        console.log(this.RefID,"RefID");
        this.cookieService.set("RefranceID", this.RefID,true);
        this.QuickpayCard();

      }
      else {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "", this.router, data);
      }
    }); 
  }



  // async quickPaymentBenefitPay() {
  //   try {
  //
  //     let body = {
  //       referenceId: this.newRefranceID,
  //       merchantId: this.newMarchentID,
  //     };
  
  //     this.commonP.presentLoading();
  
  //     const data: any = await this.topup.quickPaymentBenefitPay(body);
  
  //     if (data?.error?.response?.code == 7) {
  //       this.commonP.hideLoading();
  //       InApp.close();
  //       let failerData = data?.error?.response?.content;
  //       this.router.navigate(['/PayCardFailed'], {
  //         queryParams: { failerData },
  //       });
  //     } else if (data?.response?.code == 1) {
  //
  //       let key = this.cookieService.generateKey();
  //       this.cookieService.delete('RefranceID');
  //       this.RefID = data.response.content.benefitRef;
  //       console.log(this.RefID, 'RefID');
  //       this.cookieService.set('RefranceID', this.RefID, false, key);
  
  //       await this.QuickpayCard(); // Await navigation to ensure smooth transitions
  //     } else {
  //       this.commonP.hideLoading();
  //       this.commonP.ParseErrorAlert('', '', this.router, data);
  //     }
  //   } catch (error) {
  //     console.error('Error in quickPaymentBenefitPay:', error);
  //     this.commonP.hideLoading();
  //     this.commonP.ParseErrorAlert('', '', this.router, error);
  //   }
  // }
  


//   InititePaymentService() {

//     let body = {
//       InternalId: this.internalId,
//       VendorId: this.num, // 1 for benefit gateway, 2 for benefit pay
//       AccountType: this.prodType, // C for Card, L for Loan
//       Amount: this.amount,
//       ServiceType: "OBL",
//     };

//     this.commonP.presentLoading();
//     this.topup.InititePaymentService(this.auth.accessToken, body).then(async (data: any) => {

//       if (data?.response.code == 1) {
//         console.log("12345",data)
//         if (this.num == 2) {
//           // this.cookieService.delete("UdF1")
//             // this.cookieService.delete("UdF2")
//             // this.cookieService.delete("CardDigit")
//             // this.cookieService.delete("Accnum")
//             // let tranamount = this.amountpipe.transform(data?.response?.content?.totalAmount);


//             // let tranamount = this.amount+'.000';



//             //Concatenated string for HASH
//             // var Hstring = `appId="${data?.response?.content?.appId}",merchantId="${data?.response?.content?.merchantId}",referenceNumber="${data?.response?.content?.internalId}",transactionAmount="${tranamount.toString()}",transactionCurrency="BHD"`;
//             let totalAmount = data?.response?.content?.totalAmount;
// let tranamount = totalAmount ? this.amountpipe.transform(totalAmount) : null;

// // Safeguard to handle the case where tranamount might be null
// let tranamountStr = tranamount ? tranamount.toString() : '';

// var Hstring = `appId="${data?.response?.content?.appId}",merchantId="${data?.response?.content?.merchantId}",referenceNumber="${data?.response?.content?.internalId}",transactionAmount="${tranamountStr}",transactionCurrency="BHD"`;

//             // var Hstring = "appId='{{res?.response?.content?.appId}}',merchantId='{{res?.response?.content?.merchantId}}',referenceNumber='{{res?.response?.content?.internalId}}',transactionAmount=tranamount.toString(),transactionCurrency='BHD'";
//             console.log('Hstring', Hstring)

//             // var Hstring= 'appId="3665164969",merchantId="202009151",referenceNumber="21be40d2-8464-4ac0-8f8d-31554fa48e68",transactionAmount="6.000",transactionCurrency="BHD"'


//             //Secret Key converted in base64 from Validate payment API
//             //  let secretKey = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(res?.response?.content?.secretKey));

//             //Secret Key 
//             let secretKey = data?.response?.content?.secretKey;
//             console.log('key', secretKey);


//             // SHA256Hmac signature using HAshstring and Secret key
//             var createHash = CryptoJS.HmacSHA256(Hstring, secretKey);
//             // var createHash = CryptoJS.HmacSHA256(Hstring, secretKey).toString(CryptoJS.enc.Hex);

//             console.log('createHash', createHash);


//             //convert SHA256Hmac into base64
//             var hashInBase64 = CryptoJS.enc.Base64.stringify(createHash);
//             console.log("hashInBase64", hashInBase64);


//             var secureHash = hashInBase64;

//             console.log('secureHash', secureHash);

//             var option = {
//               appId: data?.response?.content?.appId,
//               referenceNumber: data?.response?.content?.id,
//               transactionAmount: this.amount,
//               merchantId: data?.response?.content?.merchantId,
//               transactionCurrency: "BHD",
//               hideMobileQR: false,
//               showResult: true,
//               paymentType: "web",
//               secure_hash: secureHash,
//               hashedString: createHash,
//             }
//             console.log("benefitpaybody", option)


//             let headers = new HttpHeaders();

//             headers = headers.append("s X-FOO-Signature-Type", secureHash)
//             InApp.open(option,
//               (data) => {

//                 // this.http.FooVal = ""
//                 console.log("dATA", data)
//               },
//               (error) => {

//                 console.log("error", error)
//               }, { headers }
//             )
//             this.commonP.hideLoading();

//         }
//         else {
//           let key = this.cookieService.generateKey();
//           this.transactionRefId = data?.response?.content?.id;
//           this.cookieService.set("referenceId", this.transactionRefId, false, key);
//           this.cookieService.delete("InternalId")
//           // this.cookieService.delete("prodType")
//           this.cookieService.delete("flow")
//           // this.cookieService.delete("amount")

//           window.location.href = data?.response?.content?.url;
//         }

//       }
//       else if (data?.error?.response.code == 7) {
//         this.commonP.hideLoading();
//         this.commonP.ParseErrorAlert("", "", this.router, data);
//       }
//       else {
//         this.commonP.hideLoading();
//         this.commonP.ParseErrorAlert("", "", this.router, data);
//       }
//     });
//   }

  // BenefitPay(){
  //   var benObj ={
  //     merchantId:  "",
  //     transactionAmount:"",
  //     transactionCurrency:"",
  //     hashedString:"",
  //     appId:"",
  //     referenceNumber:"",
  //     lang:'',
  //     secure_hash:'',
  //     showResult: 1   // Show results in android after payment it will navigate to browser in iOS it will keep in BenefitPay App
  //   }

  //   function successCallback(param){
  //     console.log('Test Transaction Successful');
  //     InApp.close();
  //   }
  //   // function successCallback(param) {
  //   //         //console.log(param);
  //   //         console.log('Test Transaction Successful');
  //   //         InApp.close();
  //   //         // Here do server side validation by calling the transaction status API
  //   //         //var url = "<?php echo $txnPgRequest->getRESPONSE_URL()."?refId=".$txnPgRequest->getTRACK_ID(); ?>";
  //   //         //window.location.href = url;
  //   //       }

  // }

  // open() {

  //   var option = {
  //     merchantId: "32132414",
  //     transactionAmount: "12.000",
  //     transactionCurrency: "bhd",
  //     hashedString: "dsdsaad",
  //     appId: "sdasdd",
  //     referenceNumber: "872686823613",
  //     lang: "en",
  //     secure_hash: '232434254554545',
  //     showResult: 0
  //   }
  //   InApp.open(option,
  //     (data) => {
  //       console.log("dATA", data)
  //     },
  //     (error) => {
  //       console.log("error", error)
  //     },
  //     InApp.close())
  // }

  back(){
    this.router.navigateByUrl('/PayCard');
  }

}


